import React, { Component } from 'react';
import classnames from 'classnames';
import autobind from 'autobind-decorator'
import { connect } from 'react-redux'
import { getEmptyImage } from 'react-dnd-html5-backend'
import { CategoryTypes } from '../../constants/category/DragAndDropTypes';
import { DragSource } from 'react-dnd'
import {
  openSubCategory, closeSubCategory, updateCategoryName,
  updateCategoryViewChannel, startEditMode, endEditMode,
  removeCategory, appendCategory, setEditingCategoryInfo
} from '../../actions/category'
import { showMovingCategoryPopup } from '../../actions/popup';
import GuideLine from "./GuideLine";
import { SubCategoryToggleButton, CategoryContent } from './CategoryNodeControl';


@connect(state => ({
  categoryInEditMode: state.category.categoryInEditMode,
  viewChannels: state.category.viewChannels,
  nodeCount : state.category.nodeCount,
}), dispatch => ({
  handleAppendCategory: (category) => {
    dispatch(appendCategory(category))
  },
  handleRemoveCategory: (categoryId) => {
    dispatch(removeCategory(categoryId))
  },
  handleUpdateCategoryName: (categoryId, newName) => {
    dispatch(updateCategoryName(categoryId, newName))
  },
  handleUpdateCategoryViewChannel:(categoryId, newViewChannel) => {
    dispatch(updateCategoryViewChannel(categoryId, newViewChannel))
  },
  handleStartEditMode: (categoryId) => {
    dispatch(startEditMode(categoryId))
  },
  handleEndEditMode: (categoryId) => {
    dispatch(endEditMode(categoryId))
  },
  handleEditCategoryInfo: (category) => {
    dispatch(setEditingCategoryInfo(category))
  },
  handleToggleOpened: (category, index) => {

    // 하위 카테고리를 열고 닫고 하는 동작은 카테고리가 자식 노드들을 가지고 있을 때만 수행.
    const hasChild = (category.children && (category.children.length > 0));
    if(hasChild) {
      if(category.opened) {
        dispatch(closeSubCategory(index))
      }else{
        dispatch(openSubCategory(index))
      }
    }
  },
  handleOpenMovingPopup: (category) => {
    dispatch(showMovingCategoryPopup(category))
  },
  dispatch
}))
@DragSource(CategoryTypes.NODE, {
    beginDrag(props) {
      return {
        id : props.category.id,
        category : props.category,
        index : props.index,
        parent: props.parent,
        hasChild : props.hasChild,
      }
    },
    isDragging(props, monitor) {
      return props.category.id === monitor.getItem().id;
    }
  }, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
  })
)
class CategoryNode extends Component {

  componentDidMount() {
    const { connectDragPreview } = this.props;
    connectDragPreview(getEmptyImage(), {
      captureDraggingState: false
    });
  }

  @autobind
  updateCategory(name, viewChannel) {
    const { category, handleEndEditMode, handleUpdateCategoryName, handleUpdateCategoryViewChannel } = this.props;

    if (category.name !== name) {
      handleUpdateCategoryName(category.id, name);
    }

    if (category.viewChannel !== viewChannel) {
      handleUpdateCategoryViewChannel(category.id, viewChannel);
    }

    handleEndEditMode(category.id);
  }

  @autobind
  cancelEditMode() {
    const { category } = this.props;
    const { handleRemoveCategory, handleEndEditMode } = this.props;

    if (category.id < 0 && category.name === '') {
      // name이 없는 경우 신규생성 취소이므로 node 삭제
      handleRemoveCategory(category.id);
    } else {
      handleEndEditMode(category.id);
    }
  }

  @autobind
  toggleOpenSubCategory() {
    const { handleToggleOpened, index, category } = this.props;
    handleToggleOpened(category, index);
  }

  @autobind
  handleOpenMovingPopup() {
    const { category, handleOpenMovingPopup } = this.props;
    handleOpenMovingPopup(category);
  }

  render() {
    const {
      category, parent, children, hasChild, index,
      nodeCount, viewChannels, isDragging, connectDragSource,
      handleStartEditMode, handleRemoveCategory, handleAppendCategory, handleEditCategoryInfo,
    } = this.props;

    const { categoryInEditMode } = this.props;
    const isEditMode = categoryInEditMode.filter((item) => (item === category.id)).length !== 0;

    return (
      <div className={classnames('bundle_item', {
        'open_subcate' : category.opened,
        'insert_item': isDragging
      })} >

        {index===0 &&
        <GuideLine parent={parent} category={category} placement="before"/>
        }
        <div className={classnames('item_order', {'item_edit' : isEditMode })}>
          {category.depth === 1 &&
          <SubCategoryToggleButton hasChild={hasChild} onClick={e => this.toggleOpenSubCategory()} />
          }

          <CategoryContent
            category={category}
            connectDragSource={connectDragSource}
            nodeCount={nodeCount}
            viewChannels={viewChannels}
            isEditMode={isEditMode}
            hasChild={hasChild}
            onMove={this.handleOpenMovingPopup}
            onAppend={handleAppendCategory}
            onEdit={handleStartEditMode}
            onEditInfo={handleEditCategoryInfo}
            onRemove={handleRemoveCategory}
            onEditSubmit={this.updateCategory}
            onEditClose={this.cancelEditMode}
          />
        </div>

        {children}

        <GuideLine parent={parent} category={category} placement="after" />
        {(category.depth === 1) && !hasChild &&
        <GuideLine parent={parent} category={category} addChild={true} placement="append" />
        }
      </div>
    );
  }
}


export default CategoryNode;
